import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@root/src/environments/environment';

/** Enrollment key returned by the admin API. The token and its hash are never included. */
export interface ExecutorKeyDto {
  id: string;
  name: string;
  tokenHint: string;
  tags: string[];
  maxConcurrentAssignments: number;
  revokedAt: string | null;
  lastSeenAt: string | null;
  createAt: string;
}

/** Create response. `token` is returned once and is not stored on later list rows. */
export interface ExecutorKeyCreatedDto extends ExecutorKeyDto {
  token: string;
}

export interface CreateExecutorKeyBody {
  name: string;
  tags: string[];
  maxConcurrentAssignments: number;
}

/**
 * Executor enrollment keys.
 * TODO: migrate to api-client when ExecutorKeyController is generated.
 */
@Injectable({ providedIn: 'root' })
export class ExecutorKeysService {
  private readonly http = inject(HttpClient);
  private readonly url = `${environment.api}/executor/keys`;

  list(): Observable<ExecutorKeyDto[]> {
    return this.http.get<ExecutorKeyDto[]>(this.url);
  }

  create(body: CreateExecutorKeyBody): Observable<ExecutorKeyCreatedDto> {
    return this.http.post<ExecutorKeyCreatedDto>(this.url, body);
  }

  revoke(id: string): Observable<ExecutorKeyDto> {
    return this.http.post<ExecutorKeyDto>(`${this.url}/${id}/revoke`, {});
  }

  /** Replaces capability tags and the assignment limit. The token is not returned. */
  updateTags(id: string, tags: string[], maxConcurrentAssignments: number): Observable<ExecutorKeyDto> {
    return this.http.put<ExecutorKeyDto>(`${this.url}/${id}`, { tags, maxConcurrentAssignments });
  }
}
